<template>
    <save-modal
        class="setting_modal"
        @confirm="saveSettings"
        @cancel="$emit('cancel')"
        @close="close"
    >
        <template #title>Settings</template>

        <template #body>
            <div class="setting__option">
                <p class="setting__text">View callsign labels on map</p>

                <slider-toggle-field
                    sliderContainerClass="settings__slider-toggle"
                    label=""
                    name="viewCallsignLabels"
                    :value="viewCallsignLabels"
                    @update="viewCallsignLabels = $event"
                ></slider-toggle-field>
            </div>

            <div class="setting__option">
                <p>Receive stale user alerts</p>

                <slider-toggle-field
                    sliderContainerClass="settings__slider-toggle"
                    name="receiveStaleUserAlerts"
                    label=""
                    :value="receiveStaleUserAlerts"
                    @update="receiveStaleUserAlerts = $event"
                ></slider-toggle-field>
            </div>

            <div class="setting__option">
                <p>Cluster overlapping PLIs</p>

                <slider-toggle-field
                    sliderContainerClass="settings__slider-toggle"
                    label=""
                    name="clusterOverlappingPlis"
                    :value="clusterOverlappingPlis"
                    @update="clusterOverlappingPlis = $event"
                ></slider-toggle-field>
            </div>
        </template>
    </save-modal>
</template>

<script>
import SaveModal from '@/components/Modals/SaveModal.vue'
import SliderToggleField from '@/components/SliderToggleField.vue'
import ModalFactory from '@/components/Modals/ModalFactory'
import canClose from '@/mixins/canClose'

export default {
    components: {
        SaveModal,
        SliderToggleField,
    },

    mixins: [canClose],

    props: {
        targetContainer: {
            type: [HTMLElement, String],
            default: 'body',
        },
    },

    data() {
        const settings = this.$store.getters['mission/mapSettings']
        return {
            viewCallsignLabels: settings.viewCallsignLabels,
            receiveStaleUserAlerts: settings.receiveStaleUserAlerts,
            clusterOverlappingPlis: settings.clusterOverlappingPlis,
        }
    },

    methods: {
        async saveSettings() {
            const settings = {
                ...this.$data,
            }

            try {
                await this.$store.dispatch('mission/saveMapSettings', settings)
            } catch {
                await ModalFactory.GenericMessage({
                    header: 'Save',
                    message: 'There was a problem saving your settings.',
                    acceptLabel: 'OK',
                    rejectLabel: null,
                })

                return
            }

            await ModalFactory.GenericMessage({
                header: 'Save',
                message: 'Your changes have been successfully saved.',
                acceptLabel: 'OK',
                rejectLabel: null,
            })

            this.$emit('close')
        },

        close(event) {
            const hasAnotherAlertOpen = this.hasBlockingClass(event)

            if (!hasAnotherAlertOpen) {
                this.$emit('close')
            }
        },
    },
}
</script>

<style scoped>
.setting_modal {
    position: absolute;
}

.setting__option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.3px solid #434a4d;
    margin: 0px;
    padding: 10px 0 10px 0;
}

.setting__option:first-child {
    padding-top: 0;
}

.settings__slider-toggle {
    margin: 0;
    min-height: 0;
}

.setting__text {
    margin: 0;
    padding: 0;
}

.setting__info {
    font-size: 12px;
    color: #8f999d;
    margin-left: 5px;
}

.setting__input {
    background-color: #333a3d;
    width: 150px;
    height: 32px;
    font-size: 14px;
    padding: 7px 14px 6px 10px;
    border: none;
    color: #ffffff;
}
</style>
